"use strict";

var _objectSpread = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LEFT = exports.BOTTOM = exports.RIGHT = exports.TOP = void 0;
var react_1 = __importDefault(require("react"));
function translateX(scale0, scale1, d) {
  var x = scale0(d);
  return "translate(".concat(Number.isFinite(x) ? x : scale1(d), ",0)");
}
function translateY(scale0, scale1, d) {
  var y = scale0(d);
  return "translate(0,".concat(Number.isFinite(y) ? y : scale1(d), ")");
}
exports.TOP = 'TOP';
exports.RIGHT = 'RIGHT';
exports.BOTTOM = 'BOTTOM';
exports.LEFT = 'LEFT';
var defaultAxisStyle = {
  orient: exports.BOTTOM,
  tickSizeInner: 6,
  tickSizeOuter: 6,
  tickPadding: 3,
  strokeWidth: 1,
  tickFont: 'sans-serif',
  tickFontSize: 10
};
function Axis(_ref) {
  var style = _ref.style,
    range = _ref.range,
    values = _ref.values,
    position = _ref.position,
    format = _ref.format,
    _ref$shadow = _ref.shadow,
    shadow = _ref$shadow === void 0 ? 0 : _ref$shadow,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'white' : _ref$bg,
    _ref$fg = _ref.fg,
    fg = _ref$fg === void 0 ? 'black' : _ref$fg;
  var axisStyle = _objectSpread({}, defaultAxisStyle, style);
  var orient = axisStyle.orient,
    tickSizeInner = axisStyle.tickSizeInner,
    tickPadding = axisStyle.tickPadding,
    tickSizeOuter = axisStyle.tickSizeOuter,
    strokeWidth = axisStyle.strokeWidth,
    tickFont = axisStyle.tickFont,
    tickFontSize = axisStyle.tickFontSize;
  var transform = orient === exports.TOP || orient === exports.BOTTOM ? translateX : translateY;
  var tickTransformer = function tickTransformer(d) {
    return transform(position, position, d);
  };
  var k = orient === exports.TOP || orient === exports.LEFT ? -1 : 1;
  var isRight = orient === exports.RIGHT;
  var isLeft = orient === exports.LEFT;
  var isTop = orient === exports.TOP;
  var isBottom = orient === exports.BOTTOM;
  var isHorizontal = isRight || isLeft;
  var x = isHorizontal ? 'x' : 'y';
  var y = isHorizontal ? 'y' : 'x';
  var halfWidth = strokeWidth / 2;
  var range0 = range[0] + halfWidth;
  var range1 = range[range.length - 1] + halfWidth;
  var spacing = Math.max(tickSizeInner, 0) + tickPadding;
  return react_1.default.createElement("g", {
    fill: "none",
    fontSize: tickFontSize,
    fontFamily: tickFont,
    textAnchor: isRight ? 'start' : isLeft ? 'end' : 'middle',
    strokeWidth: strokeWidth
  }, react_1.default.createElement("path", {
    stroke: fg,
    d: isHorizontal ? "M".concat(k * tickSizeOuter, ",").concat(range0, "H").concat(halfWidth, "V").concat(range1, "H").concat(k * tickSizeOuter) : "M".concat(range0, ",").concat(k * tickSizeOuter, "V").concat(halfWidth, "H").concat(range1, "V").concat(k * tickSizeOuter)
  }), values.map(function (v, idx) {
    var lineProps = {
      stroke: fg
    };
    lineProps["".concat(x, "2")] = k * tickSizeInner;
    lineProps["".concat(y, "1")] = halfWidth;
    lineProps["".concat(y, "2")] = halfWidth;
    var textProps = {
      fill: fg,
      dy: isTop ? '0em' : isBottom ? '0.71em' : '0.32em'
    };
    textProps["".concat(x)] = k * spacing;
    textProps["".concat(y)] = halfWidth;
    return react_1.default.createElement("g", {
      key: "tick-".concat(idx),
      opacity: 1,
      transform: tickTransformer(v)
    }, react_1.default.createElement("line", _objectSpread({}, lineProps)), shadow ? react_1.default.createElement("text", _objectSpread({
      style: {
        stroke: bg,
        strokeWidth: shadow
      }
    }, textProps), format(v)) : null, react_1.default.createElement("text", _objectSpread({}, textProps), format(v)));
  }));
}
exports.default = Axis;